import { type News, type NewsItemActionCreate } from '@common/clients/api';
import { NewsService } from '@common/clients/api/sdk.gen';
import { ApiService } from '@common/clients/request/ApiService';
import { type ContextData } from '@common/defaults/ContextData';
import { type UserContext } from '@common/defaults/UserContext';

export async function createNews({
    requestBody,
    contextData,
    userContext,
}: {
    requestBody: NewsItemActionCreate;
    contextData: ContextData;
    userContext: UserContext;
}): Promise<News> {
    const { data } = await ApiService({
        contextData,
        userContext,
        isClientSide: true,
        service: NewsService,
    }).createNewsByDomainId({
        path: {
            contextID: contextData.context.id,
        },
        body: requestBody,
        throwOnError: true,
    });

    return data;
}
